<template>
  <div class="payment-form-container">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-left">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/Welcome' }">
            <i class="el-icon-s-home"></i> 首页
          </el-breadcrumb-item>
          <el-breadcrumb-item>财务管理</el-breadcrumb-item>
          <el-breadcrumb-item>{{ addForm.id ? '编辑付款单' : '新增付款单' }}</el-breadcrumb-item>
        </el-breadcrumb>
       
      </div>
      <div class="header-right">
        <el-button icon="el-icon-back" size="small" @click="goBack">返回</el-button>
      </div>
    </div>

    <!-- 表单卡片 -->
    <el-card class="form-card" shadow="never">
      <el-form
        :inline="false"
        :model="addForm"
        :rules="rules"
        ref="formForRef"
        label-width="100px"
        label-position="right"
        size="small"
        class="alipay-form"
      >
        <!-- 按钮栏 -->
        <div class="form-actions">
          <el-button icon="el-icon-check" type="primary" size="small" @click="submitForm('ruleForm')" :loading="submitLoading">保存</el-button>
          <el-button type="warning" size="small" icon="el-icon-download" :disabled="!addForm.id" @click="showDoc">附件</el-button>
          <el-button icon="el-icon-close" size="small" @click="resetForm('ruleForm')">重置</el-button>
        </div>

        <!-- 基础信息行 -->
        <el-row :gutter="24">
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="费用分类" prop="cate_id">
              <el-select v-model="addForm.cate_id" placeholder="请选择费用分类" clearable>
                <el-option
                  v-for="item in cateMenus"
                  :key="item.id"
                  :label="item.pid > 0 ? '|--' + item.name : item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="收款单位">
              <el-input placeholder="请输入收款单位" v-model="addForm.payee_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="金额">
              <el-input placeholder="请输入金额" v-model="addForm.amount" type="number">
                <span slot="suffix" class="amount-suffix">元</span>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="凭证号">
              <el-input placeholder="请输入凭证号" v-model="addForm.num"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="付款日期">
              <el-date-picker
                clearable
                type="date"
                placeholder="请选择付款日期"
                v-model="addForm.pay_time"
                style="width: 100%;"
                value-format="timestamp"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="业务经办人">
              <el-input
                placeholder="请选择业务经办人"
                readonly
                v-model="formData2.name"
                @click.native="showEmployee"
                class="picker-input"
              >
                <i slot="suffix" class="el-icon-more el-input__icon"></i>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="部门">
              <el-select v-model="addForm.department_id" placeholder="请选择所属部门" clearable>
                <el-option
                  v-for="item in departmentTable"
                  :key="item.id"
                  :label="item.pid > 0 ? '|--' + item.name : item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="所属合同">
              <el-input
                placeholder="请选择所属合同"
                readonly
                v-model="formData.name"
                @click.native="chooseContract"
                class="picker-input"
              >
                <i slot="suffix" class="el-icon-more el-input__icon"></i>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="所属项目">
              <el-select v-model="addForm.project_id" placeholder="请选择所属项目" clearable>
                <el-option
                  v-for="item in formData.projectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <el-form-item label="制单人">
              <el-input placeholder="制单人" readonly v-model="addForm.creator_name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入备注"
                v-model="addForm.remark"
                maxlength="255"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 动态表格区域 -->
        <el-row :gutter="24">
          <el-col :span="24">
            <div class="table-section">
              <div class="table-toolbar">
                <el-button type="primary" icon="el-icon-plus" size="mini" @click="addItem">新增行</el-button>
              </div>
              <el-table :data="list" border size="mini" style="width: 100%;" stripe>
                <el-table-column label="支出类别名称" align="center" min-width="150">
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isEgdit">{{ scope.row.cate_name }}</span>
                    <el-select v-if="scope.row.isEgdit" v-model="scope.row.fee_category_id" placeholder="请选择分类" size="mini">
                      <el-option
                        v-for="item in cateMenus"
                        :key="item.id"
                        :label="item.pid > 0 ? '|--' + item.name : item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="结算方式名称" align="center" min-width="140">
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isEgdit">{{ scope.row.fee_way_name }}</span>
                    <el-select v-if="scope.row.isEgdit" v-model="scope.row.fee_way_id" placeholder="请选择结算方式" size="mini">
                      <el-option
                        v-for="item in feeWayList"
                        :key="item.id"
                        :label="item.pid > 0 ? '|--' + item.name : item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="乙方开户行名称" align="center" min-width="150">
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isEgdit">{{ scope.row.payee_bank_name }}</span>
                    <el-input v-if="scope.row.isEgdit" size="mini" v-model="scope.row.payee_bank_name"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="乙方银行账号" align="center" min-width="150">
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isEgdit">{{ scope.row.payee_bank_num }}</span>
                    <el-input v-if="scope.row.isEgdit" size="mini" v-model="scope.row.payee_bank_num"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="总金额" align="center" width="120">
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isEgdit">{{ scope.row.amount }}</span>
                    <el-input v-if="scope.row.isEgdit" size="mini" v-model="scope.row.amount" type="number"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="付款账号" align="center" min-width="140">
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isEgdit">{{ scope.row.payment_account }}</span>
                    <el-input v-if="scope.row.isEgdit" size="mini" v-model="scope.row.payment_account"></el-input>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" align="center" width="70">
                  <template slot-scope="scope">
                    <el-button
                      v-if="scope.row.isDel"
                      @click.native.prevent="deleteItem(scope.$index, list)"
                      type="danger"
                      size="mini"
                      icon="el-icon-delete"
                      circle
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <!-- 子组件弹窗 -->
    <eContractList
      :formData="formData"
      :visible.sync="visible"
      :title="title"
      :closeForm="closeForm"
    />
    <eEmployeeList
      :formData="formData2"
      :visible.sync="visible2"
      :title="title2"
      :closeForm="closeForm2"
    />
    <eProjectList
      :formData="formData3"
      :visible.sync="visible3"
      :title="title3"
      :closeForm="closeForm3"
    />
    <eDocList
      :formData="formData4"
      :visible.sync="visible4"
      :title="title4"
      :closeForm="closeForm4"
    />
  </div>
</template>

<script>
import eContractList from "../common/eContractList.vue"
import eDocList from "../common/eDocList.vue"
import eEmployeeList from "../common/eEmployeeList.vue"
import eProjectList from "../common/eProjectList.vue"
import moment from 'moment'
import axios from 'axios'

export default {
  name: "pmtForm",
  components: { eEmployeeList, eProjectList, eDocList, eContractList },
  data() {
    return {
      submitLoading: false,
      departmentTable: [],
      formData: {},
      visible: false,
      title: '',
      formData2: {},
      title2: '',
      visible2: false,
      formData3: {},
      title3: '',
      visible3: false,
      formData4: {},
      title4: '',
      visible4: false,
      feeWayList: [],
      uri: {},
      fileList: [],
      fileList1: [],
      addForm: {
        num: '',
        payee_name: '',
        name: '',
        upload_time: '',
        cate_id: '',
        url: '',
        id: '',
        content: '',
        amount: '',
        file_url: '',
        video_url: '',
        remark: '',
        project_id: '',
        department_id: '',
        creator_id: '',
        create_time: '',
        pay_time: '',
        creator_name: ''
      },
      cateMenus: [],
      editor: null,
      toolbarConfig: { modalAppendToBody: true },
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: { customUpload: this.uploadImg }
        }
      },
      mode: 'default',
      rules: {
        name: [{ required: true, message: "请输入产品名称", trigger: 'change' }],
        cate_id: [{ required: true, message: "请选择分类", trigger: 'change' }]
      },
      list: []
    }
  },
  mounted() {
    this.getCateMenus()
    this.getDepartmentTable()
    this.getFeeWayList()
    this.uri = this.urlParse()
    this.addForm.id = this.uri.searchParams.id
    if (this.addForm.id) {
      this.getOne()
    }
  },
  beforeDestroy() {
    if (this.editor) this.editor.destroy()
  },
  methods: {
    getFeeWayList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        code: "FeeWay"
      }
      this.$axios.dicListByPid(param).then(res => {
        if (res.code === 200) this.feeWayList = res.data
      }).catch(err => console.log(err))
    },
    closeForm() {
      this.formData = {}
      this.title = ""
      this.visible = false
    },
    chooseContract() {
      this.formData = {}
      this.title = "选择合同"
      this.visible = true
    },
    addItem() {
      const item = {
        fee_category_id: '',
        cate_name: '',
        fee_way_name: '',
        fee_way_id: '',
        payee_bank_name: '',
        payee_bank_num: '',
        amount: '',
        payment_account: '',
        isEgdit: true,
        isDel: true
      }
      this.list.push(item)
    },
    deleteItem(index, list) {
      list.splice(index, 1)
    },
    getDepartmentTable() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token')
      }
      this.$axios.findDepartmentTable(param).then(res => {
        if (res.code === 200) this.departmentTable = res.data
      }).catch(err => console.log(err))
    },
    closeForm2() {
      this.title2 = ""
      this.visible2 = false
    },
    showEmployee() {
      this.title2 = "选择员工"
      this.visible2 = true
    },
    closeForm3() {
      this.title3 = ""
      this.visible3 = false
    },
    showProject() {
      this.title3 = "选择项目"
      this.visible3 = true
    },
    closeForm4() {
      this.title4 = ""
      this.visible4 = false
    },
    showDoc() {
      this.title4 = "选择附件管理"
      this.visible4 = true
      this.formData4.source = 2
      this.formData4.foreign_id = this.addForm.id
    },
    goBack() {
      this.$router.go(-1)
    },
    submitForm() {
      this.$refs.formForRef.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const param = {
          id: this.addForm.id,
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id'),
          name: this.addForm.name,
          cate_id: this.addForm.cate_id,
          operator_id: this.formData2.id,
          contract_id: this.formData.id,
          project_id: this.addForm.project_id,
          department_id: this.addForm.department_id,
          link: this.addForm.url,
          content: this.addForm.content,
          summary: this.addForm.summary,
          ishot: this.addForm.ishot ? 1 : 0,
          recommond: this.addForm.recommond ? 1 : 0,
          istop: this.addForm.istop ? 1 : 0,
          upload_time: this.addForm.upload_time,
          create_time: this.addForm.create_time,
          pay_time: this.addForm.pay_time,
          payee_name: this.addForm.payee_name,
          amount: this.addForm.amount,
          num: this.addForm.num,
          remark: this.addForm.remark
        }
        if (this.list && this.list.length > 0) {
          param.items = this.list
        }
        this.$axios.paymentSave(param).then(res => {
          this.submitLoading = false
          if (res.code === 200) {
            this.$message.success('保存成功！')
            this.$router.push('/pmtList')
          } else {
            this.$message.error(res.msg || '保存失败')
          }
        }).catch(err => {
          console.log(err)
          this.submitLoading = false
          this.$message.error('网络异常')
        })
      })
    },
    getOne() {
      const param = {
        id: this.addForm.id,
        operator_id: sessionStorage.getItem('user_id'),
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token')
      }
      this.$axios.findPaymentOne(param).then(res => {
        if (res.code === 200) {
          const item = res.data
          this.addForm.amount = item.amount
          this.addForm.payee_name = item.payee_name
          this.addForm.cate_id = item.cate_id
          this.addForm.num = item.num
          this.addForm.remark = item.remark
          this.addForm.file_url = item.file_url
          this.addForm.pay_time = item.pay_time > 0 ? this.dateFormat(item.pay_time * 1000) : ''
          this.addForm.url = item.link
          if (this.addForm.file_url) {
            this.fileList.push({ name: this.addForm.name, url: this.addForm.file_url })
          }
        }
      }).catch(err => console.log(err))
    },
    dateFormat(time, arg = 'YYYY-MM-DD HH:mm:ss') {
      return moment(time).format(arg)
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    getCateMenus() {
      const param = {
        operator_id: sessionStorage.getItem('user_id'),
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token')
      }
      this.$axios.findFeeCategoryTable(param).then(res => {
        if (res.code === 200) this.cateMenus = res.data
      }).catch(err => console.log(err))
    },
    uploadImg(file, insertFn) {
      const param = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id')
      }
      this.$axios.getAliJson(param).then(res => {
        const data = res.data
        const suffix = this.get_suffix(file.name)
        const autoname = this.Ymdhis()
        const key = data.dir
        const host = data.host
        const request = new FormData()
        request.append('name', file.name)
        request.append("key", key + 'mrh/' + autoname + suffix)
        request.append("policy", data.policy)
        request.append("OSSAccessKeyId", data.accessid)
        request.append("success_action_status", '200')
        request.append("callback", data.callback)
        request.append("Signature", data.signature)
        request.append('file', file)
        axios.post('/alioss', request, { headers: { 'Content-Type': 'multipart/form-data' } }).then(resp => {
          const fileurl = resp.data.filename
          const fullurl = host + '/' + fileurl
          setTimeout(() => insertFn(fullurl), 500)
        }).catch(err => console.log(err))
      })
    },
    get_suffix(filename) {
      const pos = filename.lastIndexOf('.')
      return pos !== -1 ? filename.substring(pos) : ''
    },
    Ymdhis() {
      const date = new Date()
      return '' + date.getFullYear() + (date.getMonth() + 1) + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds()
    },
    urlParse(_url = '') {
      const url_obj = new URL(_url || window.location.href)
      const search_path = url_obj.search
      const handle_path = decodeURIComponent(search_path.substr(1))
      const handle_path_arr = handle_path.split('&')
      const search_params = {}
      for (let item of handle_path_arr) {
        const r = item.split('=')
        search_params[r[0]] = r[1]
      }
      return {
        protpcol: url_obj.protocol,
        search: url_obj.search,
        host: url_obj.host,
        port: url_obj.port,
        pathname: url_obj.pathname,
        searchParams: search_params
      }
    },
    onChange() {},
    onCreated(editor) {
      this.editor = Object.seal(editor)
    }
  }
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>

<style lang="scss" scoped>
// 支付宝风格变量
$primary-color: #1677ff;
$success-color: #00b42a;
$danger-color: #f53f3f;
$warning-color: #ff7d00;
$text-primary: #1f2d3d;
$text-regular: #4e5969;
$text-secondary: #86909c;
$border-color: #e5e6eb;
$bg-gray: #f7f8fa;
$card-shadow: 0 2px 8px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.02);

.payment-form-container {
  padding: 20px 24px;
  background: $bg-gray;
  min-height: calc(100vh - 84px);
}

/* 页面头部 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .header-left {
    .el-breadcrumb {
      margin-bottom: 12px;
      ::v-deep .el-breadcrumb__item {
        .el-breadcrumb__inner {
          color: $text-secondary;
          font-size: 13px;
          &.is-link {
            color: $primary-color;
            &:hover { color: lighten($primary-color, 10%); }
          }
        }
        &:last-child .el-breadcrumb__inner {
          color: $text-primary;
          font-weight: 500;
        }
      }
    }
    .title-wrapper {
      display: flex;
      align-items: baseline;
      gap: 12px;
    }
    .page-title {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
      color: $text-primary;
      letter-spacing: -0.3px;
    }
  }
  .header-right {
    .el-button {
      border-radius: 20px;
    }
  }
}

/* 表单卡片 */
.form-card {
  border-radius: 16px;
  border: none;
  box-shadow: $card-shadow;
  ::v-deep .el-card__body {
    padding: 24px;
  }
}

/* 表单样式 */
.alipay-form {
  .form-actions {
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid $border-color;
    .el-button {
      border-radius: 20px;
      padding: 7px 20px;
      font-weight: 500;
      & + .el-button {
        margin-left: 12px;
      }
    }
  }
  ::v-deep .el-form-item {
    margin-bottom: 20px;
    .el-form-item__label {
      font-weight: 500;
      color: $text-regular;
      font-size: 13px;
    }
    .el-input__inner,
    .el-textarea__inner,
    .el-select .el-input__inner,
    .el-cascader__input {
      border-radius: 8px;
      border-color: $border-color;
      transition: all 0.2s;
      &:focus {
        border-color: $primary-color;
        box-shadow: 0 0 0 2px rgba($primary-color, 0.1);
      }
    }
    .amount-suffix {
      color: $danger-color;
      font-size: 13px;
      padding-right: 8px;
    }
    .picker-input {
      cursor: pointer;
      .el-input__suffix {
        cursor: pointer;
        color: $primary-color;
      }
    }
  }
  ::v-deep .el-date-editor.el-input {
    width: 100%;
  }
}

/* 动态表格区域 */
.table-section {
  margin-top: 8px;
  .table-toolbar {
    margin-bottom: 12px;
    .el-button--primary {
      border-radius: 20px;
      background: $primary-color;
      border: none;
      padding: 5px 16px;
      &:hover {
        background: lighten($primary-color, 8%);
      }
    }
  }
  ::v-deep .el-table {
    border-radius: 12px;
    overflow: hidden;
    font-size: 13px;
    th {
      background: $bg-gray !important;
      color: $text-secondary;
      font-weight: 500;
      padding: 10px 0;
    }
    td {
      padding: 8px 0;
    }
    .el-input__inner {
      border-radius: 6px;
    }
  }
}

/* 响应式 */
@media (max-width: 768px) {
  .payment-form-container {
    padding: 16px;
  }
  .alipay-form .form-actions {
    .el-button {
      width: 100%;
      margin: 0 0 8px 0 !important;
    }
  }
}
</style>